var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    className: "event-create_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    strokeLinecap: "butt",
    d: "M60 23H4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 56H9a5 5 0 01-5-5V14a5 5 0 015-5h46a5 5 0 015 5v20M17 3v12M47 3v12M47 45v8M43 49h8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 49,
    r: 12
  }))));
}

export default SvgEventCreate;